const hasNumeric = function(value){
    let isNumeric = false;
    for(let i = 0; i < value.length; i++){
        if(!isNaN(value[i])){
            isNumeric = true;
        }
    }
    return isNumeric;
};

const hasUppercase = function(value){
    let isUppercase = false;
    for (let i = 0; i < value.length; i++){
        if(value[i].match(/[a-z]/i) && value[i] == value[i].toUpperCase()){
            isUppercase = true;
        }
    }
    return isUppercase;
};

const isValidMonth = function(value){
    let isValidMonth = true;
    if(value > 12 || value < 1){
        isValidMonth = false;
    }
    return isValidMonth;
}

export { hasNumeric, hasUppercase, isValidMonth };